import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "PFCore/hooks/queries/bookings/manage_reports/query_keys";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

type UseManageReports = {
  showManageReports: boolean;
  handleOpenManageReports: VoidFunction;
  handleCloseManageReports: VoidFunction;
};

const MANAGE_REPORTS_PARAM_NAME = "manageReports";

export const useManageReports = (): UseManageReports => {
  const { search } = useLocation();
  const history = useHistory();
  const queryClient = useQueryClient();
  const manageReportsOpened = Boolean(new URLSearchParams(search).get(MANAGE_REPORTS_PARAM_NAME));

  const [showManageReports, setShowManageReports] = useState(manageReportsOpened);

  useEffect(() => {
    const params = new URLSearchParams(search);
    params.delete(MANAGE_REPORTS_PARAM_NAME);
    history.replace({
      search: params.toString()
    });
    manageReportsOpened && handleOpenManageReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manageReportsOpened]);

  const handleOpenManageReports = () => {
    queryClient.invalidateQueries(queryKeys.reports);
    queryClient.invalidateQueries(queryKeys.templates);
    setShowManageReports(true);
  };

  const handleCloseManageReports = () => setShowManageReports(false);

  return {
    showManageReports,
    handleOpenManageReports,
    handleCloseManageReports
  };
};
